import * as React from 'react';
import Modal from 'src/modules/commons/modal-handler/jQueryModal';

export interface ChangeAmountComponentProps {
  modalRef?: Modal;
}

const ChangeAmountSuccessComponent: React.StatelessComponent<ChangeAmountComponentProps> =
  (props: ChangeAmountComponentProps) => {

    return (
      <div className="modal-content">
        <div className="modal-header">
          <p className="text-right">
        <span
          className="close-med pointer"
          onClick={() => props.modalRef!.modal('hide')}
        />
            <span className="alerted-circle"/>
            <div className="gap-20"/>
          </p>
          <h4 className="text-center">
            <strong>
              Gracias por comunicarnos tu cambio de importe
            </strong>
          </h4>
        </div>

        <div className="modal-body">

          <div className="text-center">
            El equipo de soporte al inversor se pondrá en contacto contigo para solventar esta incidencia.
          </div>
          <div className="gap-30"/>

        </div>
      </div>
    );
  };

export default ChangeAmountSuccessComponent;



// WEBPACK FOOTER //
// ./src/modules/modals/change-amount/ChangeAmountSuccess.tsx